import type { Alpha2CountryCode } from '@/lib/types/alpha2CountryCode'
import { getAlpha2WithExceptions } from '@/components/Checkout/_helpers/functions/getAlpha2WithExceptions'
import { logError } from '@/lib/utils/shared/log'
import type {
  QuotesResponse,
  QuotesItem,
  QuotesItemType,
} from './getProductPricing'

type OverridePricing = {
  userId: string | undefined
  skus: string[] | undefined
  alpha2: Alpha2CountryCode
}

export const getOverridePricing = async ({
  userId,
  skus,
  alpha2,
}: OverridePricing) => {
  const delimitedSkus = skus?.join('|')

  const postData = {
    order: {
      customer: {
        href: `${process.env.NEXT_PUBLIC_HYDRA_BASE_URL}/customers?id.unicity=${userId}`,
      },

      shipToAddress: {
        country: getAlpha2WithExceptions({ alpha2 }),
      },
    },
    vary: {
      lines: {
        items: [
          {
            item: {
              href: `${process.env.NEXT_PUBLIC_HYDRA_BASE_URL}/items?id.unicity=${delimitedSkus}`,
            },
          },
        ],
      },
    },
  }

  const options = {
    method: 'POST',
    body: JSON.stringify(postData),
    headers: {
      'Content-Type': 'application/json',
    },
  }
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_HYDRA_BASE_URL}/quotes?expand=item`,
      options,
    )

    if (!response.ok) {
      // Handle HTTP errors
      throw new Error(`HTTP error! Status: ${response.status}`)
    }

    const items: QuotesResponse = (await response.json()) as QuotesResponse

    const responseClean = items.items.map((item: QuotesItemType) => {
      const data: QuotesItem = item.lines.items[0]

      return data
    })
    return responseClean // or response.text() if the response is not JSON
  } catch (error) {
    logError('Fetch error:', error)

    return []
  }
}
